<app-new-banner></app-new-banner>
<new-flowbanner [enableHeader]="false" [showPromo]="true"></new-flowbanner>
<app-newstepper *ngIf='!isLoading' [activeStep]="4"></app-newstepper>
<app-help-to-call></app-help-to-call>
<div class="container" *ngIf="!isLoading && loaded">
  <div class="row">
    <!-- Lado izquierdo: Mensaje e imagen -->
    <div class="col-12 col-md-7 d-flex flex-column justify-content-center align-items-center text-left mb-2 mb-md-0">
      <div class="mb-3">
        <label class="h4">Ahora, completa los datos de tu inquilino</label>
      </div>
      <div class="d-none d-md-block mb-3">
        <img src="./assets/img/ContratoInquilino.png" alt="Imagen" class="img-fluid" />
      </div>
    </div>

    <!-- Lado derecho: Formulario -->
    <div class="col-12 col-md-5">
      <div class="form-container">
        <form [formGroup]="myForm" >
          <!-- <div class="mb-3">
            <label for="nombre">*Nombre de tu inquilino</label>
            <input type="text" id="nombre" name="nombre" class="form-control" placeholder="Escribe el nombre" required />
          </div> -->

          <generalinput 
    [form]="myForm" 
    controlName="FirstName" 
    [isAlphaOnly]="true" 
    label="*Nombre de tu inquilino" 
    [alertMessage]="getNameErrorMessage()" 
    placeholder="Escribe el nombre">
  </generalinput>

          <!-- <div class="mb-3">
            <label for="tipoIdentificacion">*Tipo de identificación</label>
            <input id="tipoIdentificacion" name="tipoIdentificacion" class="form-control"  placeholder="Cédula de ciudadanía" >
            
          </div> -->

          <general-select [form]="myForm" controlName="DocumentType" label="Tipo de Identificación"
         [isReFill]="true"></general-select>

          <!-- <div class="mb-3">
            <label for="documento">*Número de documento</label>
            <input type="text" id="documento" name="documento" class="form-control" placeholder="1588622475" required disabled/>
          </div> -->

          <generalinput   [form]="myForm"  controlName="DocumentNumber" [isNumberOnly]="true" label="*Número de documento"
        [alertMessage]="getDocumentNumberErrorMessage()" placeholder="Digita el número sin puntos" [isReadOnly]="true">
    </generalinput>

          <!-- <div class="mb-3">
            <label for="correo">*Correo electrónico</label>
            <input type="email" id="correo" name="correo" class="form-control" placeholder="Ej: usuario@correo.com" required />
          </div> -->


            <generalinput 
      [form]="myForm" 
    controlName="Mail" 
    label="*Correo electrónico" 
    alertMessage="Asegúrate de llenar este campo" 
    placeholder="usuario@correo.com"
    [isEmail]="true">
  </generalinput>

          <div class="mb-3">
            <small>Al continuar, <span class="text-term">aceptas <span  class="text-term interline"><a (click)="openModalTerminos()" href="" class="terminosYCondiciones" data-bs-toggle="modal"
            data-bs-target="#staticBackdrop">Términos y
            condiciones</a></span></span></small>
          </div>

        

          <button type="button" class="btn btn-primary w-100" [disabled]="!myForm.valid || isClicked" (click)="submit()">Continuar</button>
        </form>
      </div>
    </div>
  </div>
</div>

<app-footer-app></app-footer-app>


